module.exports = __webpack_public_path__ + "img/otp_page.4a0ca7d.png";